//
//
//
//
//
//

import { setOwnKey } from '@/tools'
export default {
  props: {},
  data() {
    return {
      question: {
        v_ownId: setOwnKey(),
        v_active: false,
        v_label: '段落说明',
        type: 'section',
        displayIndex: false,
        title: '请填写说明，例如：第一部分',
        backgroundColor: '#fff7ee',
        backgroundOpacity: 100,
        logic: {
          blocks: {
            typeBlock: 'all',
            list: [],
          },
        },
      },
    }
  },
  methods: {
    chooseItem() {
      this.$emit('choose', this.question)
    },
  },
}
